<template>
    <vMaterialTypeComponent :postList="postList" v-if="flag"></vMaterialTypeComponent>
</template>
<script>
import vMaterialTypeComponent from '../../listComponent/basicdata/materialType/materialTypeComponent.vue';
export default {
    name: 'materialType',
    components: {
        vMaterialTypeComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                rid: true,
                code: true,
                name: true,
                parent_rid: true
            },
            flag: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>